








import {ComponentStyle, ComponentStyleDefinition, Component, ComponentConfig, Vue, GlobalThemeConfiguration} from "@zoovu/runner-browser-api";
import {BrandingConfiguration} from "../configuration";

@Component({})
export default class BrandingView extends Vue {

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(BrandingConfiguration)
    componentConfiguration: BrandingConfiguration;

    @ComponentConfig(GlobalThemeConfiguration, true)
    globalThemeConfiguration: GlobalThemeConfiguration;

    get showBranding(): boolean {
        return (!this.componentConfiguration || this.componentConfiguration.enabled) && this.brandingLogoProvided;
    }

    get brandingLogoProvided(): boolean {
        return !!(this.globalThemeConfiguration &&
            this.globalThemeConfiguration.brandingLogoUrl &&
            this.globalThemeConfiguration.brandingLogoUrl.trim().length > 0);
    }
}

